// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"fK","controlPlay":"fL","controlElement":"fM","lowerControlWrapper":"fN","lowerControlIconWrapper":"fO","lowerControlIcon":"fP","show":"fQ"};